<template lang="pug">
div
  .financial-reports.p-M(v-if="canViewExactExports")
    ReportCard(
      v-for="(report, index) in reports"
      v-show="reportShouldBeShown(report.name)"
      :key="index"
      :title="report.title" 
      :name="report.name" 
      :description="report.description" 
      :endpoint="report.endpoint" 
      :icon="report.icon"
      :filterBy="report.filterBy"
      :customDateRangeLimit="report.customDateRangeLimit"
      :dateRangeDisabledDates="report.dateRangeDisabledDates"
      :exportNotification="report.exportNotification"
      :maxDate="report.maxDate"
      :localTimezone="localTimezone"
      :separatorValues="separatorValues"
      :defaultSeparatorValue="defaultSeparatorValue"
      :periodIsRequired="typeof report.filterBy.dateType !== 'undefined'"
    )
  div(v-else) You are not authorized to view reports
</template>

<script>
import { mapGetters } from 'vuex'
import ReportCard from './ReportCard.vue'
import { baseUrl } from '@v/apiClient.js'
import getReports from './reports.js'
import BusinessUnitIntegration from '@v/models/BusinessUnitIntegrationEnum.js'

export default {
  name: 'FinanceReports',
  components: { ReportCard },
  props: {
    canViewExactExports: {
      type: Boolean,
      default: false,
    },
    localTimezone: String,
    separatorValues: Array,
    defaultSeparatorValue: String,
  },
  data() {
    return {
      reports: getReports(baseUrl),
    }
  },
  computed: {
    ...mapGetters('briqState', ['businessUnitHasIntegration', 'businessUnitHasLegacyIntegration']),
    hasBriqPayStripeExpressIntegration() {
      return (
        this.businessUnitHasIntegration(BusinessUnitIntegration.StripeExpressTest) ||
        this.businessUnitHasIntegration(BusinessUnitIntegration.StripeExpress) ||
        this.businessUnitHasLegacyIntegration(BusinessUnitIntegration.StripeExpressTest) ||
        this.businessUnitHasLegacyIntegration(BusinessUnitIntegration.StripeExpress)
      )
    },
    hasRootlineIntegration() {
      return (
        this.businessUnitHasIntegration(BusinessUnitIntegration.RootlineTest) ||
        this.businessUnitHasIntegration(BusinessUnitIntegration.Rootline) ||
        this.businessUnitHasLegacyIntegration(BusinessUnitIntegration.RootlineTest) ||
        this.businessUnitHasLegacyIntegration(BusinessUnitIntegration.Rootline)
      )
    },
  },
  methods: {
    reportShouldBeShown(reportName) {
      if (reportName === 'briqPayExport') {
        return this.hasBriqPayStripeExpressIntegration
      }
      if (reportName === 'rootlineExport') {
        return this.hasRootlineIntegration
      }
      return true
    },
  },
}
</script>

<style scoped lang="stylus">
.financial-reports
  display flex
  flex-wrap wrap
</style>
